import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

import Mailbox from './Mailbox'

export default styled(Mailbox)`
  &&& {
    color: ${th('colors.tealBlue')};
  }
`
